import HeroWrapper from '@ulta/components/HeroWrapper/HeroWrapper';

export default HeroWrapper;